import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const NOTES_QUERY_KEY = ["notes"] as const;

type NoteType = components["schemas"]["NoteType"];
type NoteSortKey = components["schemas"]["NoteSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListNotesQuery = {
  include_deleted?: boolean;
  note_type?: NoteType;
  tag_id?: string;
  trade_id?: string;
  favorited?: boolean;
  search?: string;
  sort_key?: NoteSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

// Shared query definition reused by the hook and by nav prefetch.
export function notesQueryOptions(client: ApiClient, params: ListNotesQuery = {}) {
  return {
    queryKey: [...NOTES_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/notes", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list notes");
      }
      return data;
    },
  };
}

export function useNotes(params: ListNotesQuery = {}) {
  const client = useApiClient();
  return useQuery(notesQueryOptions(client, params));
}
